export default __webpack_public_path__ + "static/media/HunnysDDS.1f1a009e.jpeg";